import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../../services/auth.api";

export default function PrivateRoute({ children }) {
  // The stored user is the API's own `{ id, name, phone, roles, … }` summary —
  // there is no nested `profile` object any more.
  return isAuthenticated() ? children : <Navigate to="/authentication/login" replace />;
}
